export default "__VITE_ASSET__DEtnU1po__"